// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs-items[data-v-1890dc68]{background-color:transparent}.wrap-text[data-v-1890dc68]{white-space:normal}", ""]);
// Exports
module.exports = exports;
